import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ngx-agora',
  template: `
    <p>
      ngx-agora works!
    </p>
  `,
  styles: []
})
export class NgxAgoraComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
